module.exports = __webpack_public_path__ + "static/media/senseview-front-pic.28917fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/senseview-front-pic.jpg
// module id = 90
// module chunks = 0